<template>
  <div class="carousel" @mouseenter="stopTimer" @mouseleave="startTimer">
    <div class="carousel-inner" :style="{ transform: `translateX(-${currentIndex * 100}%)` }">
      <div class="carousel-item" v-for="(image, index) in images" :key="index" @click="handleBannerClick(index)">
        <div class="image-wrapper">
          <img :src="image" alt="Banner" />
        </div>
      </div>
    </div>
    
    <!-- 精致的分页器 -->
    <div class="carousel-pagination">
      <div 
        v-for="(image, index) in images" 
        :key="index" 
        class="page-indicator"
        :class="{ active: currentIndex === index }"
        @click="currentIndex = index"
      >
        <div class="indicator-bar"></div>
      </div>
    </div>
    
    <!-- 悬浮控制按钮 -->
    <div class="carousel-controls">
      <button class="ctrl-btn prev" @click="prev">
        <i class="el-icon-arrow-left"></i>
      </button>
      <button class="ctrl-btn next" @click="next">
        <i class="el-icon-arrow-right"></i>
      </button>
    </div>
  </div>
</template>

<script>
import { getAdList } from '@/api/ad'

export default {
  name: 'Carousel',
  data() {
    return {
      currentIndex: 0,
      images: [],
      bannerList: [],
      timer: null
    }
  },
  mounted() {
    this.fetchBannerList()
  },
  beforeDestroy() {
    this.stopTimer();
  },
  methods: {
    async fetchBannerList() {
      try {
        const res = await getAdList()
        if (res && res.code === 200 && res.rows && res.rows.length > 0) {
          const adData = res.rows[0]
          if (adData.picMsgArray) {
            const picList = JSON.parse(adData.picMsgArray)
            this.bannerList = picList
            this.images = picList.map(item => item.fileList)
          }
        }
        if (this.images.length > 0) {
          this.startTimer()
        }
      } catch (error) {
        console.error('获取轮播图数据失败:', error)
        this.images = [
          'https://alimg.szlcsc.com/upload/public/home/page/advertising/20251217/2E24C84D47E8196B7A3BA40379A8AA79.jpg'
        ]
        this.startTimer()
      }
    },
    startTimer() {
      if (!this.timer && this.images.length > 1) {
        this.timer = setInterval(this.next, 5000);
      }
    },
    stopTimer() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
    next() {
      if (this.images.length > 0) {
        this.currentIndex = (this.currentIndex + 1) % this.images.length;
      }
    },
    prev() {
      if (this.images.length > 0) {
        this.currentIndex = (this.currentIndex - 1 + this.images.length) % this.images.length;
      }
    },
    handleBannerClick(index) {
      const banner = this.bannerList[index]
      if (banner && banner.link) {
        window.open(banner.link, '_blank')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.carousel {
  width: 100%;
  height: 480px;
  overflow: hidden;
  position: relative;
  background: #fdfdfd;

  .carousel-inner {
    display: flex;
    height: 100%;
    transition: transform 0.6s cubic-bezier(0.4, 0, 0.2, 1);
  }

  .carousel-item {
    min-width: 100%;
    height: 100%;
    padding: 0 10px;
    box-sizing: border-box;

    .image-wrapper {
      width: 100%;
      height: 100%;
      border-radius: 12px;
      overflow: hidden;
      box-shadow: 0 4px 25px rgba(0,0,0,0.05);
      cursor: pointer;
      
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        transition: transform 0.8s ease;
      }
      
      &:hover img {
        transform: scale(1.02);
      }
    }
  }

  /* 分页器样式 */
  .carousel-pagination {
    position: absolute;
    bottom: 25px;
    left: 40px;
    display: flex;
    gap: 8px;
    z-index: 10;

    .page-indicator {
      width: 30px;
      height: 4px;
      cursor: pointer;
      padding: 10px 0;
      
      .indicator-bar {
        width: 100%;
        height: 100%;
        background: rgba(255,255,255,0.3);
        border-radius: 4px;
        transition: all 0.3s;
      }

      &.active .indicator-bar {
        background: #d97706;
        width: 45px;
        box-shadow: 0 0 10px rgba(217, 119, 6, 0.4);
      }
    }
  }

  /* 左右控制按钮 */
  .carousel-controls {
    .ctrl-btn {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      width: 44px;
      height: 44px;
      background: rgba(255, 255, 255, 0.2);
      backdrop-filter: blur(10px);
      border: 1px solid rgba(255, 255, 255, 0.3);
      color: #fff;
      border-radius: 50%;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 20px;
      transition: all 0.3s;
      opacity: 0;
      z-index: 10;

      &:hover {
        background: #d97706;
        border-color: #d97706;
        box-shadow: 0 4px 15px rgba(217, 119, 6, 0.3);
      }

      &.prev { left: 30px; }
      &.next { right: 30px; }
    }
  }

  &:hover .ctrl-btn {
    opacity: 1;
    &.prev { transform: translateY(-50%) translateX(5px); }
    &.next { transform: translateY(-50%) translateX(-5px); }
  }
}

// 响应式

@media (min-width: 1400px) {
  .carousel { height: 480px; }
}
@media (max-width: 1399px) and (min-width: 1200px) {
  .carousel { height: 420px; }
}

@media (max-width: 1199px) and (min-width: 992px) {
  .carousel { height: 380px; }
}

@media (max-width: 991px) and (min-width: 768px) {
  .carousel { 
    height: 320px;
    .carousel-item { padding: 0 5px; }
    .page-indicator { width: 20px; }
    .ctrl-btn { width: 32px; height: 32px; font-size: 16px; }
  }
}
</style>
